import React from 'react';
import {Lang} from './LangContext';
import {Currency} from 'models/billing';
import {getLocale} from '../../common/i18n/locales';

export type LocaleData = {
    code: string;
    lang: Lang;
    region: string;
    currency: Currency;
    tld: string;
};

export interface Locale extends LocaleData {
    name: string;
    langName: string;
    regionName: string;
}

export default React.createContext<Locale>(getLocale('ru-RU') as Locale);
